import { z } from 'zod';
import { AccountTypeSchema } from './coa.js';
import { MoneySchema } from './common.js';
// Prisma's Decimal columns serialize to JSON as strings. Server-side, the
// ledger service stages everything through decimal.js and emits canonical
// strings on the wire — but allow `number` too so client code can pass either.
const DecimalLike = z.union([MoneySchema, z.coerce.number()]);
// Account "nature" tells the ledger how to sign Dr-vs-Cr movements when
// computing running balance:
//   ASSET / EXPENSE → DR-nature  (Dr increases the balance)
//   LIABILITY / EQUITY / REVENUE → CR-nature  (Cr increases the balance)
// This mirrors normal double-entry rules and the GL Schedule (glsched) view.
export const AccountNatureSchema = z.enum(['DR', 'CR']);
export const LedgerLineSchema = z.object({
    voucherNo: z.string(),
    voucherDate: z.coerce.date(),
    description: z.string(),
    lineDescription: z.string().nullable(),
    refKey: z.string().nullable(),
    debit: DecimalLike,
    credit: DecimalLike,
    // Signed per Dr/Cr nature so the column reads natively as a running balance.
    runningBalance: DecimalLike,
});
export const LedgerResponseSchema = z.object({
    account: z.object({
        code: z.string(),
        nameTh: z.string(),
        nameEn: z.string(),
        type: AccountTypeSchema,
        nature: AccountNatureSchema,
    }),
    openingBalance: DecimalLike,
    closingBalance: DecimalLike,
    totals: z.object({
        debit: DecimalLike,
        credit: DecimalLike,
    }),
    rows: z.array(LedgerLineSchema),
});
// Wire-shape query — `period` (YYYYMM) is a convenience that resolves to
// [first-of-month, last-of-month]. Explicit dateFrom/dateTo win when both given.
export const LedgerQuerySchema = z.object({
    accountCode: z.string().min(1),
    dateFrom: z.iso.date().optional(),
    dateTo: z.iso.date().optional(),
    period: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
});
//# sourceMappingURL=ledger.js.map